import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFeatureFlags } from '../../../../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../../../../flags';
import HereMaps from '../../../common/HereMaps';
import { usePreviewMap } from '../hooks';
import { FALLBACK_HERE_API_KEY } from '../../../../config';

const PreviewMap: React.FC = () => {
  const { latitude, longitude, hasCoordinates } = usePreviewMap();
  const { getFeatureValue } = useFeatureFlags();

  const configOverride = getFeatureValue(FeatureFlags.NGW_CONFIG_OVERRIDE) as
    | { HERE_API_KEY?: string }
    | undefined;
  const apiKey =
    configOverride?.HERE_API_KEY ||
    process.env.REACT_APP_HERE_API_KEY ||
    FALLBACK_HERE_API_KEY;

  if (!hasCoordinates || !apiKey) {
    return (
      <Box
        sx={{
          height: 400,
          bgcolor: 'grey.100',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 1,
        }}
      >
        <Typography color="text.secondary">Map not available</Typography>
      </Box>
    );
  }

  return (
    <HereMaps
      apiKey={apiKey}
      latitude={latitude}
      longitude={longitude}
      height={400}
      disableDragging={true}
      showInfoCard={false}
      onLocationChange={() => {}}
      zoom={15}
    />
  );
};

export default React.memo(PreviewMap);
